export default __webpack_public_path__ + "static/media/swt2.89de90a7.svg";